var $ = require("jquery");

var scroll;
var hideAt = 136;

(function () {
    loadSprite("/static/images/sprites/Sprite.svg");
    loadSprite("/static/images/sprites/Icon-sprite.svg");
    loadSprite("/static/images/sprites/Campaign-sprite.svg");

    function loadSprite(src) {
        $.get(src, function (data) {
            var div = document.createElement("div");
            div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
            div.style = "height: 0;"
            document.body.insertBefore(div, document.body.childNodes[0]);
        });
    }
})();

window.SetFocusToElement = (element) => {
    element.focus();
};
